import { deepCopyBetGroup } from './deepCopyBetGroup';

export function deepCopyAggs(aggsList) {
    const aggs = {};
    const keys = Object.keys(aggsList);
    let pi = 0;
    let sportId = 0;

    let i = keys.length % 8;

    while (i) {
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        i--;
    }

    i = Math.floor(keys.length / 8);

    // Process 8 per loop
    while (i) {
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        sportId = keys[pi++];
        aggs[sportId] = deepCopyBetGroup(aggsList[sportId]);
        i--;
    }

    return aggs;
}
